module.exports = __webpack_public_path__ + "bd10bf4e026e0a054ea950785b067336.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/wings/down-8.png
// module id = 2513
// module chunks = 0